import React from 'react';
import { Tenant } from '../types';
import { BuildingOffice2Icon } from '@heroicons/react/24/outline';

interface TenantBadgeProps {
  tenant: Tenant;
  showCode?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const TenantBadge: React.FC<TenantBadgeProps> = ({
  tenant,
  showCode = true,
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  return (
    <div
      className={`inline-flex items-center gap-2 bg-blue-50 text-blue-700 rounded-md font-medium ${sizeClasses[size]}`}
      title={tenant.description || tenant.tenantName}
    >
      <BuildingOffice2Icon className={`${iconSizes[size]} flex-shrink-0`} />
      <span className="truncate">
        {tenant.tenantName}
        {showCode && (
          <span className="text-blue-600 ml-1">
            ({tenant.tenantCode})
          </span>
        )}
      </span>
    </div>
  );
};
